import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Bid.css";
import { LuWarehouse } from "react-icons/lu";
import { Link } from "react-router";
import FairHousingLogo from "../../../public/assets/images/home/FairHousingLogo";
const BidFooter = () => {
  return (
    <footer className="text-dark pt-4 pb-3 mt-auto border-top">
      <Container>
        <Row className="text-center text-md-start footer_bid">
          <Col xs={12} md={12} className="">
            <p className="footerr-section-copy">
              Property is available to all persons, regardless of race, color,
              religion, sex, handicap, familial status, or national origin.
            </p>
            <div className="footerr-section-copy mb-2">
              <Link
                to="/about/about-us"
                className="me-2 text-decoration-none text-dark"
              >
                About Us
              </Link>{" "}
              |
              <Link
                to="https://www.altisource.com/Privacy-Policy/"
                className="mx-2 text-decoration-none text-dark"
              >
                Your Privacy Rights
              </Link>{" "}
              |
              <Link
                to="/about/terms"
                className="mx-2 text-decoration-none text-dark"
              >
                Terms & Conditions
              </Link>{" "}
              |
              <Link
                to="/disclaimer"
                className="ms-2 text-decoration-none text-dark"
              >
                Disclaimer & Trademark
              </Link>
            </div>
          </Col>

          <Col xs={12} md={12} className="">
            <div>
              <span className="footerr-section-copy ">
                TREC:
                <Link
                  to="https://image-prod.hubzu.com/about-hubzu-images/AOA-IABS.pdf"
                  className="ms-2 me-2 text-decoration-underline text-dark"
                >
                  Info About Brokerage Services
                </Link>{" "}
                |
                <Link
                  to="https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-5_0.pdf"
                  className="ms-2 text-decoration-underline text-dark"
                >
                  Consumer Protection Notice
                </Link>
              </span>
              <p className=" d-flex align-items-center mt-2">
                <p style={{ fontSize: "1rem" }}>
                  <FairHousingLogo />
                </p>
                <p
                  className="footerr-section-copy"
                  style={{ marginLeft: "10px" }}
                >
                  Fair Housing and Equal Opportunity. © 2012 - 2026 Altisource.
                  All Rights Reserved
                </p>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default BidFooter;
